export default __webpack_public_path__ + "static/network icon-cf9a8eedfa794265bfca2ecd8478db29.png";